// JS for build a box feature(product-box-template.liquid). Added by Alfie from InsCoder [June 17,20217]
(function(){

  let tartCount = 0
  const maxTart = document.querySelector('.build-a-box__status').getAttribute('data-max-item')
  const $qtyControlBtn = document.querySelectorAll('.qty-wrap .qty-btn')
  const $addToCartTartsBtn = document.querySelector('.js-AddToCartAllSelectedTarts')
  const $viewCartBtn = document.querySelector('.js-ViewCart')
  const $addedToCartMsg = document.querySelector('.add-to-cart-msg')
  const $buyNowBtn = document.querySelector('.js-BuyNowBtn')
  const $buttonGroups = document.querySelector('.js-buttonGroups')
  const $quickPurchaseBuyBtn = document.querySelector('.quick-purchase-bar__purchase-button-custom')

  const isOrderReady = () => {
    document.querySelectorAll('.status-count').forEach(statusCount => statusCount.classList.add('completed'))
    $buttonGroups.classList.remove('buttonGroups-inactive')
    $quickPurchaseBuyBtn.classList.remove('inactive')
    // re-add below for fix (it was removed)
    $quickPurchaseBuyBtn.style.pointerEvents = 'auto';
  }
  const isOrderNotReady = () => {
    document.querySelectorAll('.status-count').forEach(statusCount => statusCount.classList.remove('completed'))
    $buttonGroups.classList.add('buttonGroups-inactive')
    $quickPurchaseBuyBtn.classList.add('inactive')
//     setTimeout(() => {
//       $quickPurchaseBuyBtn.setAttribute('href', '#')
//     }, 1000);
    // comment-out above and re-add below for fix (it was removed)
    $quickPurchaseBuyBtn.setAttribute('href', '#')
    $quickPurchaseBuyBtn.style.pointerEvents = 'none';
  }

  // check if order is ready
  const isMaxTartsSelected = (count) => count == maxTart ? isOrderReady() : isOrderNotReady()

  function updateSelectedTarts(tartCurrentCount) {
    const count = tartCurrentCount > 0 ? tartCurrentCount : 0
    document.querySelectorAll('.selected-tarts').forEach(selectedTart => selectedTart.innerHTML = count)
  }

  function cloneStatusComponent() {
    const $statusCount = document.querySelector('.status-count');
    const clone = $statusCount.cloneNode(true);
    document.querySelector('.quick-purchase-bar__product').appendChild(clone)
  }

  function qtyControl(btn) {
    const $thisButton = btn
    const dataQty = $thisButton.closest('.build-a-box__item')
    const $qtyValue = $thisButton.closest('.qty-wrap').querySelector('.qty-value')
    const isPlusBtn = $thisButton.classList.contains('qty-btn-plus')
    const incrementValue = parseInt($qtyValue.value) + 1
    const decrementValue = $qtyValue.value > 0 ? parseInt($qtyValue.value) - 1 : 0

    if(isPlusBtn) {
      if(tartCount < maxTart) {
        $qtyValue.value = incrementValue
        dataQty.setAttribute('data-qty', incrementValue)
        tartCount++
        updateSelectedTarts(tartCount)
      }
      isMaxTartsSelected(tartCount)
    }
    else {
      if($qtyValue.value != 0) {
        $qtyValue.value = decrementValue
        dataQty.setAttribute('data-qty', decrementValue)
        tartCount--
        updateSelectedTarts(tartCount)
      }
      isMaxTartsSelected(tartCount)
    }
  }

  function resetBuildForm() {
    // rest forms
    document.querySelectorAll('.build-a-box__item').forEach(item => item.setAttribute('data-qty', 0))
    document.querySelectorAll('.build-a-box__item .qty-value').forEach(qty => qty.value = 0)
    document.querySelectorAll('.selected-tarts').forEach(selectedTart => selectedTart.innerHTML = 0)
    tartCount = 0
    document.querySelector('[data-quantity-input]').value = 1
    isOrderNotReady()
  }
  // function resetAddToCartButton() {
  //   $viewCartBtn.classList.add('hide-this')
  //   $addedToCartMsg.classList.add('hide-this')
  //   $addToCartTartsBtn.classList.remove('hide-this')
  // }

  function addToCartAllTarts(event, buttonType) {
    event.preventDefault()

    console.log('tartCount < maxTart', tartCount, maxTart)
    console.log('[data-quantity-input]', document.querySelector('[data-quantity-input]').value)
    // Don't submit if not yet complete i.e. max number of tartes per box
    if(tartCount < maxTart || tartCount != maxTart) return false

    let selectedVariantItems = { items: [] }
    let selectedTartsItems = { items: [] }
    let itemsInCartDrawer = ''
    const $tarts = document.querySelectorAll('.build-a-box__items .build-a-box__item')
    const $cartDrawer = document.querySelector('.quick-cart')

    $tarts.forEach(tart => {
      const tartQty = tart.getAttribute('data-qty') * document.querySelector('[data-quantity-input]').value // multiple by Quantity
      const tartID = tart.getAttribute('data-id')
      const tartImg = tart.getAttribute('data-img-src')
      const tartUrl = tart.getAttribute('data-url')
      if(tartQty > 0) selectedVariantItems.items.push(
        {
          quantity: tartQty,
          id: tartID
        }
      )
    })

    $tarts.forEach(tart => {
      const quantity = tart.getAttribute('data-qty')
      const id = tart.getAttribute('data-id')
      const img = tart.getAttribute('data-img-src')
      const url = tart.getAttribute('data-url')
      const title = tart.getAttribute('data-title')
      const price = tart.getAttribute('data-price')
      if(quantity > 0) selectedTartsItems.items.push({ quantity, id, img, url, title, price })
    })

    $addToCartTartsBtn.classList.add('loading')

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(selectedVariantItems),
    })
    .then(response => {
      $addToCartTartsBtn.classList.remove('loading')

      // Update SubTotal
      fetch('/cart.js').then(function (response) {
        // The API call was successful!
        return response.json();
      }).then(function (data) {
        // This is the JSON from our response
        console.log('data', data)
        const dataItems = data.items.map(item => `${item.id}:${item.quantity}`)
        document.querySelector('[data-buy-now-button]').setAttribute('href', `/cart/${dataItems}`);
        document.querySelector('[data-subtotal]').innerHTML = Shopify.formatMoney(data.total_price, themeVariable.moneyFormat).replace(/\"/g,'')

        // prepare item in cart drawer
        const selectedTarts = data.items.map(item => {
          const tartQty = item.quantity
          const tartID = item.id
          const tartImg = item.image
          const tartUrl = item.url
          const tartTitle = item.title
          const tartPrice = item.price
          return `
            <div class="quick-cart__item ff-body fs-body-base" data-id="${ tartID }" data-quantity="${ tartQty }">
              <div class="quick-cart__item-left">
                <a href="/products/sesame-matcha-tarte?variant=${ tartID }">
                  <div class="quick-cart__image"><img class="image__img ls-is-cached lazyloaded" alt="${ tartTitle }"
                    data-src="${ tartImg }"
                    src="${ tartImg }">
                  </div>
                </a>
              </div>
              <div class="quick-cart__item-middle">
                <h4 class="fs-body-bold"><a href="${ tartUrl }">${ tartTitle }</a></h4>
                <div>
                  ${ Shopify.formatMoney(tartPrice, themeVariable.moneyFormat).replace(/\"/g,'') }
                  <span class="c-subdued">x ${ tartQty }</span>
                </div>
              </div>
              <div class="quick-cart__control">
                <div class="quick-cart__control-top">
                  <button class="quick-cart__button quick-cart__button-increase" data-increase="${ tartID }" aria-label="Subtract product quantity">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M12 5v14M5 12h14"></path>
                      </svg>
                    </div>
                  </button>
                  <button class="quick-cart__button quick-cart__button-decrease" data-decrease="${ tartID }" aria-label="Add product quantity">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14"></path>
                      </svg>
                    </div>
                  </button>
                  <button class="quick-cart__button quick-cart__button-remove" data-remove="${ tartID }" aria-label="Remove">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            `
        }).join('')

        // display selected items in cart drawer
        document.querySelector('.quick-cart__items').innerHTML = selectedTarts

        // show cart drawer
        if(buttonType != 'buy_now') {
          document.querySelector('[data-js-cart-icon]').click()
          document.querySelector('.quick_cart__empty').classList.remove('visible')
          document.querySelector('.quick-cart__footer').classList.add('visible')
        }

        // update cart count in header
        document.querySelectorAll('[data-js-cart-count]').forEach(cartCount => cartCount.innerHTML = data.item_count)

        // display view cart button & hide add to cart button
        // $viewCartBtn.classList.remove('hide-this')
        // $addedToCartMsg.classList.remove('hide-this')
        // $addToCartTartsBtn.classList.add('hide-this')

        // when click buy now redirect to cart page
        if(buttonType == 'buy_now') window.location.href = '/cart'

        // reset build form after add to cart
        resetBuildForm()

      }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  // On load init
  resetBuildForm()
  // resetAddToCartButton()
  cloneStatusComponent()

  $qtyControlBtn.forEach(btn => btn.addEventListener('click', () => qtyControl(btn)))
  $addToCartTartsBtn.addEventListener('click', event => addToCartAllTarts(event))
  $buyNowBtn.addEventListener('click', event => addToCartAllTarts(event, 'buy_now'))
  $quickPurchaseBuyBtn.addEventListener('click', event => addToCartAllTarts(event, 'buy_now'))

})();